import { CHAT_ROUTE_KEY } from '@fs/zion-chat'

const supportConfig = {
  chat: {
    askUsAnything: {
      locales: ['de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh', 'zh-hans'],
      route: CHAT_ROUTE_KEY.CREATE_SUPPORT_CHAT,
    },
    floatingButton: {
      hiddenPaths: [
        '/session/*',
        '/speakers/*',
        '/special-session/:id',
        '/registered-session',
        '/expohall/:boothId',
        '/dashboard',
        '/call-for-presentations',
        '/vendor-linking/:id',
        '/volunteer',
        '/volunteer/*',
      ],
    },
    event: {
      labelPrefix: `rootstech_`,
    },
    community: {
      route: CHAT_ROUTE_KEY.CHAT,
      groupId: {
        integration: 'fs_rootstech:pgfvx53-20220302_conference_chatsvr_familysearch_org',
        beta: 'fs_rootstech:rqnf7rj-20231212101202_J9HB',
        www: 'fs_rootstech:rskd98v-20230224185751_prod-J9HB',
      },
    },
  },
  help: {
    communityUrls: {
      ar: 'https://community.familysearch.org/en',
      de: 'https://community.familysearch.org/de',
      en: 'https://community.familysearch.org/en',
      es: 'https://community.familysearch.org/es',
      fr: 'https://community.familysearch.org/fr',
      hu: 'https://community.familysearch.org/en/categories/magyar',
      id: 'https://community.familysearch.org/en',
      it: 'https://community.familysearch.org/it',
      ja: 'https://community.familysearch.org/ja',
      km: 'https://community.familysearch.org/en',
      ko: 'https://community.familysearch.org/ko',
      mn: 'https://community.familysearch.org/en',
      nl: 'https://community.familysearch.org/en/categories/nederlands',
      no: 'https://community.familysearch.org/en/categories/norsk',
      pl: 'https://community.familysearch.org/en',
      pt: 'https://community.familysearch.org/pt',
      ru: 'https://www.facebook.com/groups/familysearchrus',
      sm: 'https://community.familysearch.org/en',
      th: 'https://community.familysearch.org/en',
      to: 'https://community.familysearch.org/en',
      vi: 'https://community.familysearch.org/en',
      zh: 'https://community.familysearch.org/zh',
      'zh-hans': 'https://community.familysearch.org/zh',
    },
    consultationUrls: {
      de: 'https://go.oncehub.com/deutsche',
      en: 'https://go.oncehub.com/ResearchStrategySession',
      es: 'https://go.oncehub.com/consultaenlinea',
      fr: 'https://go.oncehub.com/consultationsenligne',
      it: 'https://go.oncehub.com/consulenzevirtuali',
      ja: '',
      ko: 'https://www.familysearch.org/ko/fieldops/apac-%EC%9A%B0%EB%A6%AC%EC%97%90%EA%B2%8C-%EC%97%B0%EB%9D%BD%ED%95%98%EA%B8%B0-%EB%B6%80%EB%A6%84-%EC%9D%BC%EC%A0%95-%EA%B3%84%ED%9A%8D%ED%95%98%EA%B8%B0',
      mn: '',
      nl: 'https://go.oncehub.com/onlineconsultaties',
      pt: 'https://go.oncehub.com/consultasvirtuais',
      ru: '',
      th: 'https://go.oncehub.com/ResearchStrategySessionsThai',
      zh: 'https://go.oncehub.com/ResearchStrategySessionMandarin',
      'zh-hans': 'https://go.oncehub.com/ResearchStrategySessionMandarin',
    },
  },
}

export default supportConfig
